{
  "AGENT_MGMT": {
    "HEADER": "Nhà cung cấp",
    "HEADER_BTN_TXT": "Thêm nhà cung cấp / đại lý",
    "LOADING": "Tải danh sách nhà cung cấp",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Quản trị viên",
      "AGENT": "Nhà cung cấp"
    },
    "TABS": {
      "ACTIVE": "Đang hoạt động",
      "DEACTIVATED": "Đã vô hiệu hóa"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Ngắt kết nối Điện thoại",
      "API": {
        "SUCCESS_MESSAGE": "Đã ngắt kết nối điện thoại của nhân viên thành công",
        "ERROR_MESSAGE": "Không thể ngắt kết nối điện thoại của nhân viên, vui lòng thử lại sau"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Kích hoạt lại",
      "API": {
        "SUCCESS_MESSAGE": "Đã kích hoạt lại nhân viên thành công",
        "ERROR_MESSAGE": "Không thể kích hoạt lại nhân viên, vui lòng thử lại sau"
      },
      "CONFIRM": {
        "TITLE": "Xác nhận Kích hoạt lại",
        "MESSAGE": "Bạn có chắc chắn muốn kích hoạt lại ",
        "YES": "Có, Kích hoạt lại ",
        "NO": "Không, Huỷ "
      }
    },
    "LIST": {
      "404": "Không có tác nhân nào được liên kết với tài khoản này",
      "TITLE": "Quản lý các đại lý trong nhóm của bạn",
      "DESC": "Bạn có thể thêm / bớt đại lý vào / trong nhóm của mình.",
      "NAME": "Tên",
      "EMAIL": "EMAIL",
      "STATUS": "Trạng thái",
      "ACTIONS": "Hành động",
      "VERIFIED": "Đã xác minh",
      "VERIFICATION_PENDING": "Đang chờ xác minh",
      "API_ALLOWED": "API đã bật",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Thêm đại lý vào nhóm của bạn",
      "DESC": "Bạn có thể thêm những người có thể xử lý hỗ trợ cho hộp thư đến của bạn.",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "FORM": {
        "NAME": {
          "LABEL": "Tên nhà cung cấp",
          "PLACEHOLDER": "Vui lòng nhập tên nhà cung cấp"
        },
        "AGENT_TYPE": {
          "LABEL": "Loại nhà cung cấp",
          "PLACEHOLDER": "Vui lòng chọn loại",
          "ERROR": "Loại nhà cung cấp là bắt buộc"
        },
        "EMAIL": {
          "LABEL": "Email",
          "PLACEHOLDER": "Vui lòng nhập email"
        },
        "SUBMIT": "Thêm nhà cung cấp"
      },
      "API": {
        "SUCCESS_MESSAGE": "Nhà cung cấp được thêm thành công",
        "EXIST_MESSAGE": "Email đã được sử dung, vui lòng chọn email khác.",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Xoá",
      "API": {
        "SUCCESS_MESSAGE": "Nhà cung cấp được xoá thành công",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      },
      "CONFIRM": {
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có muốn xoá? ",
        "DESCRIPTION": "Nhân viên sẽ bị đăng xuất ngay lập tức, bị xóa khỏi tất cả các nhóm và hộp thư đến, và sẽ không thể truy cập tài khoản này nữa.",
        "YES": "Có, xoá ",
        "NO": "Không, giữ "
      }
    },
    "EDIT": {
      "TITLE": "Chỉnh sửa nhà cung cấp",
      "FORM": {
        "NAME": {
          "LABEL": "Tên nhà cung cấp",
          "PLACEHOLDER": "Vui lòng nhập tên nhà cung cấp"
        },
        "AGENT_TYPE": {
          "LABEL": "Loại nhà cung cấp",
          "PLACEHOLDER": "Vui lòng chọn loại",
          "ERROR": "Loại nhà cung cấp là bắt buộc"
        },
        "EMAIL": {
          "LABEL": "Emails",
          "PLACEHOLDER": "Vui lòng nhập email"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Khả dụng",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "API_ACCESS": {
          "LABEL": "Bật quyền truy cập API",
          "HELP": "Quyền truy cập API mặc định không bật. Khi bật, khóa API cá nhân của đại lý này có thể được sử dụng trên mọi tài khoản mà họ thuộc về. Việc đăng nhập vào bảng điều khiển không bị ảnh hưởng."
        },
        "SUBMIT": "Chỉnh sửa nhà cung cấp"
      },
      "BUTTON_TEXT": "Chỉnh sửa",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Nhà cung cấp được cập nhật thành công",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Đặt lại mật khẩu",
        "ADMIN_SUCCESS_MESSAGE": "Một email với hướng dẫn đặt lại mật khẩu đã được gửi đến đại lý",
        "SUCCESS_MESSAGE": "Đặt lại mật khẩu đại lý thành công",
        "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "Không tìm thấy kết quả."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Không có",
      "TITLE": {
        "AGENT": "Chọn thành viên",
        "TEAM": "Chọn nhóm"
      },
      "LIST": {
        "NONE": "Không có"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Không tìm thấy nhà cung cấp",
          "TEAM": "Không tìm thấy nhóm nào"
        },
        "PLACEHOLDER": {
          "AGENT": "Tìm kiếm nhân viên",
          "TEAM": "Tìm kiếm nhóm",
          "INPUT": "Tìm nhân viên"
        }
      }
    }
  }
}
